import { Component, OnInit, Input, Output, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';
import { ChartAccount } from 'src/app/chart-accounts/shared/chart-account.model';
import { ChartAccountService } from 'src/app/chart-accounts/shared/chart-account.service';
import { SessionService } from 'src/app/_shared/services/session.service';
import { SharedModule } from 'src/app/_shared/shared.module';

@Component({
  selector: 'app-product-category-accounting',
  templateUrl: './product-category-accounting.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class ProductCategoryAccountingComponent implements OnInit {
  @Input() category: any;
  @Input() defaultLanguage: any;

  chartAccounts: ChartAccount[] = [];
  meta: any[];

  incomeAccountControl = new FormControl('');
  expenseAccountControl = new FormControl('');

  incomeAccount: string = '';
  expenseAccount: string = '';

  filteredIncomeAccounts: Observable<any[]>;
  filteredExpenseAccounts: Observable<any[]>;

  loadingChartAccounts: boolean = false;
  invalidChartAccounts: boolean = true;
  sendingChartAccounts: boolean = false;

  filterCriteria = this.chartAccountService.getFilterCriteria();
  private companyId = this.sessionService.getSelectedAccountCompany().id;

  constructor(
    private chartAccountService: ChartAccountService,
    private sessionService: SessionService,
    @Inject('ProductCategoryService') private ProductCategoryServicejs: any
  ) {}

  ngOnInit(): void {
    this.getChartAccounts();
  }

  applyChartAccounts() {
    this.category.income_account_id = this.incomeAccount;
    this.category.expense_account_id = this.expenseAccount;

    this.sendingChartAccounts = true;
    this.ProductCategoryServicejs.applyAccounting(this.category).then((response) => {
      this.category = response;
      this.sendingChartAccounts = false;
    });
  }

  cancelChartAccounts() {
    this.incomeAccountControl.reset();
    this.expenseAccountControl.reset();
  }

  validateInputs() {
    this.invalidChartAccounts =
      this.incomeAccountControl.value !== '' && this.expenseAccountControl.value !== ''
        ? false
        : true;
  }

  private filtered(chartAccounts: any) {
    let incomeChartAccounts = chartAccounts.filter(
      (chartAccount) => chartAccount.chart_account_type.name === 'Income'
    );

    this.filteredIncomeAccounts = this.incomeAccountControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || '', incomeChartAccounts))
    );

    let expenseChartAccounts = chartAccounts.filter(
      (chartAccount) => chartAccount.chart_account_type.name === 'Expenses'
    );

    this.filteredExpenseAccounts = this.expenseAccountControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || '', expenseChartAccounts))
    );
  }

  private _filter(value: string, chartAccounts: any): string[] {
    const filterValue = value.toLowerCase();

    return chartAccounts.filter(
      (option) =>
        option.code.toLowerCase().includes(filterValue) ||
        option.name.toLowerCase().includes(filterValue)
    );
  }

  incomeSelected(value: any) {
    this.incomeAccount = value;
  }

  expenseSelected(value: any) {
    this.expenseAccount = value;
  }

  private getChartAccounts() {
    this.filterCriteria.company_id = this.companyId;
    this.filterCriteria.by_chart_account_types = 'Income,Expenses';

    this.loadingChartAccounts = true;
    this.chartAccountService.getChartAccounts(this.filterCriteria).subscribe((response) => {
      this.chartAccounts = response.data;
      this.meta = response.meta;
      this.chartAccounts.forEach((chartAccount) => {
        if (chartAccount.id === this.category.income_account_id) {
          this.incomeAccountControl.setValue(`${chartAccount.code} ${chartAccount.name}`);
          this.incomeAccount = chartAccount.id;
          this.invalidChartAccounts = false;
        }
        if (chartAccount.id === this.category.expense_account_id) {
          this.expenseAccountControl.setValue(`${chartAccount.code} ${chartAccount.name}`);
          this.expenseAccount = chartAccount.id;
          this.invalidChartAccounts = false;
        }
      });

      this.filtered(this.chartAccounts);

      this.loadingChartAccounts = false;
    });
  }
}
